import React, { useEffect, useState, Suspense } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import Helmet from 'react-helmet';
import AppConfig from '../../domain/AppConfig';
import AppService from '../../service/AppService';
import CustomPageHeader from './CustomPageHeader';
import CustomPageFooter from './CustomPageFooter';
import CustomPageDetail from './CustomPageDetail';
import CustomPageTitle from './CustomPageTitle';

const appConfig: AppConfig = AppService.appConfig();

const CustomPage = (props) => {

  let {
    customPageCache,
  } = props;

  let [selectedLink, setSelectedLink] = useState();

  //One time init
  useEffect(() => {
    if (window.location.hash) {
      if (document.querySelector(window.location.hash) !== null) {
        setTimeout(() => {
          let selectElement = document.querySelector('a[href="' + window.location.hash + '"]');
          setSelectedLink(window.location.hash);
          selectElement.click();
        }, 1000);
      }
    }

    let options = {
      root: null,
      rootMargin: '-94px 0px 0px 0px',
      threshold: [0, 0.1, 0.25, 0.5, 0.75, 0.99, 1],
    };

    let io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        let isBlockTitle = false;
        let getId = entry.target.getAttribute('id');
        if (!getId) {
          getId = 'page_block_' + entry.target.getAttribute('data-pageblockid');
          isBlockTitle = true;
        }
        const target = entry.target;
        if (entry.isIntersecting) {
          // console.log("getId isIntersecting", getId, isBlockTitle, entry.intersectionRatio, entry.boundingClientRect.y, entry.rootBounds);
          if (entry.boundingClientRect.y < 94 && isBlockTitle) {
            setSelectedLink(getId);
          }
          if (entry.boundingClientRect.y >= 94 && !isBlockTitle && selectedLink === getId) {
            setSelectedLink(undefined);
          }
        } else {
          // console.log("getId is NOT Intersecting", getId, isBlockTitle, entry.intersectionRatio, entry.boundingClientRect.y, entry.rootBounds);
          if (entry.boundingClientRect.y < 94 && !isBlockTitle && selectedLink === getId) {
            setSelectedLink(null);
          }
        }
      });
    }, options);

    let blocks = document.getElementsByClassName('m_bdBox');
    if (blocks.length > 0) {
      blocks.forEach((el) => {
        io.observe(el);
      });
    }

    let blockTitles = document.getElementsByClassName('customPage-pageBlock-title');
    if (blockTitles.length > 0) {
      blockTitles.forEach((el) => {
        io.observe(el);
      });
    }
  }, []);

  const isPageTypeEvent = (customPageCache) => {
    return customPageCache.pageTypeId === '6';
  };

  const isPageHeader = (customPageCache) => {
    return customPageCache.headerBlock.headerType === "CUSTOM_HEADER";
  }
  const isPageFooter = (customPageCache) => {
    return customPageCache.footerBlock.footerType === "CUSTOM_FOOTER";
  }

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8"/>
        <meta property="og:title" content={customPageCache.pageTitle}/>
        <meta property="og:description" content={customPageCache.pageSubTitle}/>
        <meta property="og:image" content={customPageCache.pageImageUrl}/>
        {isPageTypeEvent(customPageCache) &&
          <link rel="stylesheet" type="text/css" href={`${appConfig.cdnHost}/common/css/doterai.css`}/>
        }
        {isPageTypeEvent(customPageCache) &&
          <script src={`${appConfig.cdnHost}/common/js/doterai.js`} />
        }
      </Helmet>
      <Suspense fallback={<h1 style={{ display: 'none' }}>LOADING</h1>}>
        {isPageTypeEvent(customPageCache) ? (
          <>
            { isPageHeader(customPageCache) &&
              <CustomPageHeader headerBlock={customPageCache.headerBlock} selected={selectedLink}/>
            }
            <div id="page-wrapper" className={"page-type-"+customPageCache.pageTypeId}>
              <CustomPageDetail customPageCache={customPageCache}/>
            </div>
            { isPageFooter(customPageCache) &&
              <CustomPageFooter footerBlock={customPageCache.footerBlock}/>
            }
          </>) : (
          <>
            <CustomPageDetail customPageCache={customPageCache}/>
          </>
        )}
      </Suspense>
    </div>
  );

};

CustomPage.fragments = {
  customPageCache: gql`
      fragment CustomPage_customPageCache on CustomPageCacheResponseSchemaType {
          pageTypeId
          pageTitle
          pageSubTitle
          pageImageUrl
          companyContractId
          headerBlock {
              ...CustomPageHeader_headerBlock
          }
          footerBlock {
              footerType
          }
          ...CustomPageDetail_customPageCache
      }
      ${CustomPageHeader.fragments.headerBlock}
      ${CustomPageDetail.fragments.customPageCache}
  `,
};

CustomPage.propTypes = {
  customPageCache: PropTypes.object.isRequired,
};

export default CustomPage;


